module.exports = __webpack_public_path__ + "static/media/clock-round-black.d207ac45.svg";